module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "c1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "chnum"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "ct1"
    }
  }, [_vm._v("CHAPTER ONE")])]), _c('a', {
    attrs: {
      "id": "ct1"
    }
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_vm._v("The Lone Wolf Strikes")])]), _c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "ct1"
    }
  }, [_vm._v("‘Ambition was born in my breast, and … along with this new ambition there was born in me as well a distinct dislike for all two-seated German flying machines… Many people think of the two-seater as a superior fighting machine because of its greater gun-power. But to me [it] always seemed [to be] fair prey and an easy target …’"), _c('br'), _vm._v("– William A. Bishop"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn1",
      "id": "c1_fnr1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tuesday, 28 May 1918 was a mostly sunny day"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn2",
      "id": "c1_fnr2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(", heralding the arrival of summer. In the sky over Ypres, Belgium, a dark mottled German two-seat biplane circled the war-ravaged old city, occasionally swooping low over buildings and roads pummelled into the Flemish soil during nearly four years of artillery and troop assaults. With fierce Allied resistance to another German assault now underway, it was too dangerous for the aeroplane continually to orbit overhead, where it could be seen against the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every time the two-seater rose up, it headed north west, so the aerial observer could view\n"), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("\nBritish artillery units firing at German positions. Through high-powered binoculars, he looked for big red muzzle flashes. Like a high-altitude sniper armed with a wireless telegraph, once he spotted his quarry, he tapped out its location to a ground station, which directed artillery units against the British gun emplacement. The observer sent messages confirming target hits or to adjust their fire.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p011_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("The Rumpler C.VII was Germany’s premier high-altitude reconnaissance aeroplane. Powered by a 240-hp super-compressed Maybach engine, the two-seater could reach altitudes approaching 24,000 feet. (Greg VanWyngarden)")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p012_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("Line-up of Royal Aircraft Factory S.E.5a fighters assigned to 85 Squadron, RAF. Billy Bishop flew the aeroplane in the foreground – C.1904 – in the last thirteen aerial combats in which he was credited with aerial victories. (Greg VanWyngarden)")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Eyes in the Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The experienced observer, twenty-three-year-old Leutnant der Reserve [Second-Lieutenant, Reserves] Hanns-Gerd Rabe, knew that Allied single-seat fighters would be looking for his aeroplane. He and his pilot, Unteroffizier [Corporal] Peter Johannes, scanned the skies for tell-tale distant specks – Allied aircraft bent on shooting them down in order to save lives among their own ground forces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Johannes drew Rabe’s attention to a small, growing spot in the distance. It turned out to be a lone British single- seat aeroplane. Rabe later recalled:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("‘It was quite far off, so I was not worried about one Tommy fighterplane. Then he seemed to have disappeared, perhaps to find a more opportune target.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I returned to looking at the target area with my binoculars, watching for the next shell to hit. Suddenly an S.E.5a fighter aeroplane came between me and the target and filled my view. It was gaining fast and through the binoculars I could see the aeroplane as if I were next to it. The first thing I noticed was the white octagon insignia on the fuselage side and a big white letter next to it. I recognised the symbols from a report I had read recently. "), _c('i', [_vm._v("Mein Gott!")]), _vm._v(" It was Bishop, the British Richthofen!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We had to make a fast dive for our lines. The engine was not yet at full power, so I leaned over to my pilot and yelled: “Dive for home! Right now or we are done for!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("‘He gave full power and pushed the machine over into a streaking dive eastwards. I looked through the binoculars at Mr. Bishop, who became smaller and smaller, and I was overjoyed that we had managed to elude this master fighter pilot. If given a choice, I would always avoid combat and the possible loss of the exposed photographic plates and notes I had made earlier in the flight.’"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn3",
      "id": "c1_fnr3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p013_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("Fl.-Abt (A) 253 observer Ltn.d.Res Hanns-Gerd Rabe (left) and his pilot, Uffz Peter Johannes (middle), also flew low-level reconnaissance missions in Hannover Cl.IIIa 2714/18. The ‘bird’ insignia on the fuselage alludes to the name Rabe [Raven]. Aircraft mechanic Noll is at right. (Author’s Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wary of tricks, Rabe tightly gripped the stock of his machine gun. He was ready to fend off any aeroplane that attacked from behind or – even worse – from above, with the sun at its back, making it difficult to see. Likewise, Johannes readied his forward-firing machine gun in case any adversary impeded their retreat.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Rabe’s decision was vindicated that evening, when he and Johannes were back at Flieger-Abteilung (A) 253’s airfield at Pont à Marcq, France, some seventeen miles south east of Ypres. Their comrades agreed that the lone British attacker must have been the (then) forty-eight-victory fighter ace Major William A. Bishop, VC, DSO and Bar, MC, and that there was no shame in declining to fight such a formidable opponent."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn4",
      "id": "c1_fnr4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p013_02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("Major William A. Bishop, VC, DSO and Bar, MC, was a forty-eight-victory ace when he pursued Ltn.d.Res Rabe and Uffz Johannes on 28 May 1918. (Directorate of History and Heritage, Department of National Defence photo RE-16579-1)")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p014_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("The Albatros D.III enjoyed a long service life. Seen here is an aeroplane built by the company’s subsidiary OAW (East German Albatros Works) in Schneidemühl and decorated in summer 1918 national insignia. (Dr. Volker Koos)")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("At age twenty-four, Billy Bishop enjoyed a formidable reputation among German airmen, who whispered his name with fear."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn5",
      "id": "c1_fnr5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" But later that morning, Billy – as he was called by most people – was still angry with himself for failing to shoot down the two-seater.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After lunch Bishop flew another solo hunting mission, heading eastward toward Courtemarck, where he attacked two Albatros biplane fighters. At day’s end, his usual high spirits were restored by his latest successes and he easily dismissed the opponent that got away. He wrote about it to his wife:")]), _vm._v(" "), _c('p', {
    staticClass: "quote1"
  }, [_vm._v("‘I went up to the lines this morning and only succeeded in frightening a fat two-seater to death. He ran for all he was worth, so I didn’t follow. This afternoon, however, was my lucky moment. I spied nine Albatros [fighters] under me … The two back ones were higher than the rest, so I went after them. They saw me when I was 150 yards away. I opened fire on one, twenty rounds, and passed on to the second one, who was doing a climbing turn. I [put] thirty rounds into him and then zoomed and saw the second one burst into flames. Then looking over, the first one, 600 feet lower, [was] also in flames. I then left well enough alone and cleared off, easily getting away from the remainder.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn6",
      "id": "c1_fnr6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Conflicting Reports")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That letter is the most detailed surviving account of Billy’s combat activities on 28 May 1918. Copies of combat reports about his morning and afternoon patrols have not been found in the UK National Archives or in any other such known resource in Britain or Canada. He was credited with scoring his forty-ninth and fiftieth aerial victories"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn7",
      "id": "c1_fnr7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" in that day’s entry in the Royal Air Force War Diary. They were among twenty-eight EA [enemy\n"), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("\naeroplanes] credited as having been shot down by RAF airmen that day."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn8",
      "id": "c1_fnr8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Yet, the German weekly "), _c('i', [_vm._v("Nachrichtenblatt")]), _vm._v(" [air intelligence summary] for the period listed only eight losses – three aircraft reported missing and five shot down across the entire Western Front."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn9",
      "id": "c1_fnr9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" A post-war German aviation necrology,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn10",
      "id": "c1_fnr10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" however, lists twenty-three air-related deaths on 28 May 1918; of that number nineteen occurred over the Western Front."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn11",
      "id": "c1_fnr11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Determining which of those casualties Billy Bishop caused is complicated by reports from the German 4th Army air staff, over whose sector the Canadian pilot’s combats occurred. Hauptmann [Captain] Helmuth Wilberg, who was the 4th Army’s officer in charge of aviation, reported five casualties within his area that day. His listing included Gefreiter [Lance-Corporal] Peisker, a pilot with the Pfalz D.IIIa-equipped fighter unit Jagdstaffel 7, who was reported as being ‘lightly injured while making an emergency landing’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn12",
      "id": "c1_fnr12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" But Jasta 7’s commanding officer, Ltn.d.Res Josef Jacobs, had not mentioned Gefr Peisker’s incident in his war diary; rather, he recorded that another pilot, Uffz Sicho, ‘had been shot up by an S.E.5a and was wounded in the arm and upper leg’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn13",
      "id": "c1_fnr13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Jacobs stated that Sicho’s wounds resulted from an early morning encounter with ‘five S.E.5s who were [fighting] with a formation of Albatros D.V’ aircraft."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn14",
      "id": "c1_fnr14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The preceding assemblage of casualty information does not help identify which German aircraft or unit Billy encountered, but it demonstrates the confusing array of facts to be considered in arriving at a hypothesis. Further, in his letter that evening, Billy Bishop said he saw both Albatros fighters on fire. Possibly, one or both German pilots managed to extinguish the flames or make a ‘controlled crash’ that wrecked the aircraft but did not kill the pilots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One remarkable aspect about aerial combat during World War I is that, often, opponents were able to recognise each other. Easily the best-known example is the series of red (or mostly red) fighter aircraft flown by Germany’s top-scoring fighter ace, Rittmeister [Cavalry Captain] Manfred Freiherr von Richthofen, the pilot to whom Ltn.d.Res Rabe alluded when he recognised Bishop pursuing him on 28 May. In addition to being easily identified in the air, Richthofen’s distinctive aircraft helped create a bogey-man image, which at least put his opponents on edge. Similarly, Billy’s rapid rise to high-scoring ace status made him of high interest to his German counterparts. Shared word-of-mouth descriptions of Allied squadron markings (often revealed in prisoner of war interrogations) and the sight of a fighter aircraft, whose pilot was so bold as to operate like a lone wolf, convinced Rabe that a single S.E.5a bearing a white octagon and large white number on the fuselage must have been Billy Bishop’s. Rabe’s letter home, describing the date, time of day and location of his encounter matched the incident that Bishop described to his wife. That historical evidence led this author to conclude that Rabe and Bishop most likely had an aerial encounter over Ypres.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are many facets to Billy Bishop’s story. Before delving into the air combat role for which he is best known, the man and events that shaped him should be considered.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Family History")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy Bishop was descended from people with strong convictions and the courage to act on them. An example of those qualities is his Puritan ancestor John Seaman, who left England in 1630, during the tumultuous reign of King Charles I, for a more stable life in North\n"), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("\nAmerica. Seaman sailed aboard one of eleven ships led by John Winthrop to the Massachusetts Bay Colony. From there, Seaman set out for neighbouring Connecticut and then to Long Island, where he found success."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn15",
      "id": "c1_fnr15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well over a century later, when increasing numbers of American colonists sought independence from England, Bishop’s maternal great-great-grandfather, Caleb Seaman II, remained loyal to the British crown. Following the American Revolution and the subsequent British troop withdrawal in 1783, Seaman was continually harassed about his sentiments. Consequently, six years later, he and his wife and their two children moved to Canada, where Caleb became a blacksmith near the village of Rockville."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn16",
      "id": "c1_fnr16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Caleb’s son Nehemiah married the daughter of another loyalist-émigré family, Margaret McCready. Their daughter, Eliza Ann Seaman, married Hiram Kilbourn in 1838 and, as a result of that union, the Bishop name entered the family history. After the Kilbourns moved"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn17",
      "id": "c1_fnr17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" to ‘the boom town of Owen Sound … [a] port on Georgian Bay, the world’s largest fresh-water bay’,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn18",
      "id": "c1_fnr18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" they established a tannery. As the business grew, in 1853 they hired nineteen-year-old leatherworker Eleazar Wilson Bishop. He fell in love with the Kilbourns’ sixteen-year-old daughter and only child, Sarah Sophia; the following year the couple ran away to be married.")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p016_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("Billy Bishop’s parents, Will and Margaret, at home in Owen Sound, Ontario. The elder Bishop was clerk of the High Court and registrar of the Surrogate Court for Grey County and always dressed accordingly. (Billy Bishop Home and Museum)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eleazar Bishop tried several business ventures and went broke. Then, his wife took charge of supporting the family, eventually six children. Sarah worked all day long at cooking, cleaning, sewing and other domestic work. Eleazar and Sarah’s oldest son, William Avery Bishop, showed such promise that his mother saved money to send him to Osgoode Hall (now part of York University), one of Canada’s leading law schools. But before Will Bishop, as he was known, left to pursue his studies he became engaged to Margaret Louise Greene."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn19",
      "id": "c1_fnr19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p017_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("The red brick house at 948 Third Avenue West in Owen Sound, where Billy Bishop lived until he entered the Royal Military College. The house is now the Billy Bishop Home and Museum, which kindly provided this pre-World War I photograph.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The couple set out on a much more successful life path than Will’s parents had. Arthur Bishop noted:")])]), _c('p', {
    staticClass: "quote1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("‘Margaret Louise … and Will Bishop … grew up together. They were married soon after Will returned to practice [law] in Owen Sound and Will staked his future by building an elegant Victorian home for his bride. They moved into it just before their first son … was born in 1884.’ "), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn20",
      "id": "c1_fnr20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday’s Child")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That child was named Reginald Worth Bishop, and went by Worth; a good student who set a good example for other siblings to come. A 1903 graduate of Canada’s Royal Military College, Worth was successful in his military and civilian endeavours."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn21",
      "id": "c1_fnr21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" A second son, Kilbourne, was born in 1886, but died at age seven. On Thursday, 8 February 1894, ‘their third son was born, an eleven-pound baby with a full head of blond hair and bright blue eyes. True to the line in an old fortune telling children’s rhyme – ‘Thursday’s child has far to go’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn22",
      "id": "c1_fnr22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v("– the younger Bishop boy had quite a future ahead of him. He was named after his father, William Avery"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn23",
      "id": "c1_fnr23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(", but he was not listed as ‘Junior’; rather, he was called Billy. The following year, the Bishops’ last child was born; baptised as Mary Louise, she became known as Louie."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn24",
      "id": "c1_fnr24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Will Bishop became involved in Liberal Party politics in the 1896 national election and,\n"), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("\ntwo years later, he was appointed as clerk of the High Court and registrar of the Surrogate Court for Grey County."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn25",
      "id": "c1_fnr25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" Will Bishop had an office in the local court house and, following the custom of the time, he wore formal attire. His younger son looked and acted very much like Will and so Margaret Louise dressed Billy in similar finery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The youngster’s well-dressed look was noticed by male schoolmates who singled out boys who were ‘different’ from them. The more aggressive lads criticised Billy’s fine clothes and his disdain for competitive team sports; rather, he enjoyed ‘shooting, riding and swimming’. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn26",
      "id": "c1_fnr26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" He ‘was undoubtedly the only pre-teenaged boy in Owen Sound who enjoyed attending [dancing] classes …’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn27",
      "id": "c1_fnr27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consequently, Billy ‘developed formidable fighting skills and won the respect of his peers with his fists in numerous schoolyard scraps’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn28",
      "id": "c1_fnr28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Indeed, he augmented his physical toughening with hand-eye coordination skills that would serve him well as a fighter pilot. His father bought Billy a membership in the local YMCA, where executing good shots in the billiard room challenged his manual dexterity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next, the teenager received a .22-calibre rifle and practiced marksmanship, a skill that would help him when he became an air fighter. Spurred by the incentive of twenty-five cents for every squirrel he shot, Billy learned the art of deflection shooting – aiming his gun beyond a moving target to anticipate its movement – and earned quite a few dollars for his talent.")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p018_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("Billy Bishop and his sister, Mary Louise, were very close, as this childhood view shows. (Billy Bishop Home and Museum)")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("A Budding Aviator")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("In 1910, sixteen-year-old Billy Bishop built and tested his own ‘flying machine’, actually an unpowered glider. Based on newspaper photos of contemporary aircraft, he constructed a craft out of a crate and other wood, cardboard and bed sheets, all held together with heavy string. After his ‘flight’, the local newspaper charitably called Billy’s craft ‘a real credit to the inventive mind of this lad’. "), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn29",
      "id": "c1_fnr29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arthur Bishop’s book offered a more critical view:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘[Billy] hauled it off to the roof of the family home, took his place in the orange-crate cockpit, and skidded down the steep roof into space. His descent was more a nose-dive than a flight. The twenty-eight-foot fall demolished the machine, but Billy scrambled out of the wreckage with no more than a bruised knee and a scratched ear … [The] incident …[became] the first of many violent contacts between the earth’s surface and aircraft piloted by William Avery Bishop, near disasters which became known simply as “Bishop landings”.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn30",
      "id": "c1_fnr30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Immediately after the incident, his sister Louie helped clean him up and dispose of the wreckage. But she sought compensation. One of her friends was hosting a girl from Toronto and asked whether Billy, who was popular with the local young ladies, would take the guest to a local dance. Billy agreed to consider the out-of-town girl. Louie invited her friend and the other girl, Margaret Burden, over for refreshments on the veranda, where Billy viewed the new girl from behind dining room curtains.")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p019_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("Billy Bishop presenting a dapper look in his Royal Military College cadet uniform. (DHH/DND photo RE-21098)")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("The Girl from Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy liked what he saw and, as if struck by lightning, became totally smitten by Margaret. From that point forward, he spent all of his free time with her. Early Bishop biographer Alan Hynd described the quickly blossoming love between the young couple:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘Billy was an outdoor boy, and he used to point out to her [the] gaily coloured birds that a … girl never saw in the city. [Margaret] talked about him so much that the\n"), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("\ntwo families eventually became acquainted. Fall came, and she went away. But she didn’t forget, and neither did he.’ "), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn31",
      "id": "c1_fnr31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In this case, however, the course of young love had to overcome a big obstacle. Margaret was born into one of country’s wealthiest families. Her grandfather was Timothy Eaton, founder of the Canadian retail empire that bore his name. As Arthur Bishop described his parents’ early situation:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘It was a strangely democratic confrontation of the grandson of the least successful merchant of Owen Sound and the granddaughter of the most successful merchant of all Canada … At the time that Eleazar’s grandson took Timothy’s granddaughter dancing, Eleazar had not earned a dollar for many a year – and Timothy had ceased counting his millions.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn32",
      "id": "c1_fnr32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Margaret’s parents, Charles and Margaret Burden, did not encourage a romantic attachment between their daughter and the unpromising lad from Owen Sound. Indeed, her father tried to break up the relationship several times. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn33",
      "id": "c1_fnr33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Billy Bishop had little to offer Margaret. He was an unenthusiastic student with no plans for the future. In a discussion with the boy’s parents, the local high school principal once described Billy in an unwittingly prescient way: ‘As far as I can see, the only thing your son is good at is fighting.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn34",
      "id": "c1_fnr34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" But Billy was in love and made up his mind to win Margaret’s heart – and allay her parents’ fears that he would not amount to much.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("The Royal Military College")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy demonstrated his serious intent, on 8 February 1911 – his seventeenth birthday – when he applied for admission to the Royal Military College of Canada. The RMC trained future officers and conferred a degree that would benefit them when they left military service.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Billy Bishop’s RMC tenure from August 1911 until September 1914 has been portrayed unfavourably in some published accounts. However, J. Ross McKenzie, curator of the RMC Museum, drew on existing college records to produce a 1990 essay"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn35",
      "id": "c1_fnr35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" that offers more accurate views of Billy’s cadet days, as follows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Billy is said to have lived in the shadow of his older brother, Worth, who reportedly achieved ‘the highest standing of any cadet in the history of [the] RMC’ up to that time."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn36",
      "id": "c1_fnr36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" College records show that Worth Bishop ‘did reasonably well’ and placed ‘ten out of twenty- six on graduation’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn37",
      "id": "c1_fnr37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Billy was accepted as RMC Gentleman Cadet No. 943, ‘having placed forty-second out of the forty-three men who passed the entrance exam’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn38",
      "id": "c1_fnr38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" According to Arthur Bishop, on the evening of Monday, 28 August 1911,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn39",
      "id": "c1_fnr39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" ‘Billy and forty [sic] other nervous recruits entered the ancient complex of stone buildings on the banks of the St. Lawrence [River] … across the harbour from the city of Kingston, Ontario’. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn40",
      "id": "c1_fnr40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that time, the ‘RMC had a three-year programme and … classes were known from junior to senior as the 3rd Class, 2nd Class and 1st Class’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn41",
      "id": "c1_fnr41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" In addition to military drill exercises, the college provided classes in ‘mathematics, physics, English, French, civil and\n"), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("\nmilitary engineering, and military tactics’, as well as such extracurricular activities as ‘boxing, football, hockey, gymnastics, aquatics … cricket and horsemanship …’"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn42",
      "id": "c1_fnr42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("RMC offered the advantages of a civilian university, with the prospect of an interesting career. But the college’s rigid discipline and stern life were as cold as the institution’s century-old stone walls. An RMC history points out from Billy Bishop’s experience that ‘each first-year man was soundly trounced every Saturday night on the theory that seniors, however vigilant, must have overlooked some recruit crimes during the week. Bishop [said he] was “profoundly distressed by the indignities” of his first year at the college, which included being compelled to eat a live spider.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn43",
      "id": "c1_fnr43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Billy dared not raise his very effective fists against his tormentors, a breach of conduct that would have resulted in his expulsion from the college. But he ended an altogether dreary first year by being ‘suspended … a punishment short of expulsion, [which] was rarely used’. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn44",
      "id": "c1_fnr44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" McKenzie’s examination of the records showed that during Billy’s 1911-1912 academic year he was caught cheating on a year-end examination. It was a serious charge and ‘college authorities would not hesitate to expel cadets [for it]’, McKenzie noted. But, ‘while [Bishop’s] transgression was serious, [he] was obviously deemed worthy of a second chance’. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn45",
      "id": "c1_fnr45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Surely, Billy felt too ashamed to return home for a summer respite. Instead, he prevailed upon his brother to help find a temporary job. At the time Worth Bishop was a government engineer on a canal navigation system and secured a spot for Billy as a timekeeper. The work gave the younger man time to reflect on his first year away from home. It also provided Worth an opportunity to counsel Billy to improve his performance at the RMC."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn46",
      "id": "c1_fnr46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While he had been granted provisional second-year status, Billy had to spend another year at the college. If he failed the test again, his RMC days would be over. True to his word, Billy worked harder and bolstered his academic record. McKenzie notes: ‘In his repeated 3rd Class year, the academic year 1912-1913, Bishop showed marked improvement, he placed twenty-third out of forty-two, a respectable showing’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn47",
      "id": "c1_fnr47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Billy Bishop’s third year at RMC has been characterised as ‘an epic of rules broken and discipline scorned. His regular sorties – legal and illegal – into Kingston town to rendezvous with girls became the talk of the stone frigate.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn48",
      "id": "c1_fnr48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" That account includes allegations of lying to a superior officer and using crib notes on a final examination, which, if true, could have resulted in Billy Bishop’s expulsion. Yet, RMC Museum Curator McKenzie, who had unique access to various college administrative paperwork, pointed out: ‘There is absolutely nothing to suggest that a “cheating” incident took place in [May] 1914. Bishop’s marks did drop, however. He placed thirty-third out of thirty-four. Not quite the goat, but close …’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn49",
      "id": "c1_fnr49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("McKenzie’s research shows that at the end of the 1913-1914 academic year Billy Bishop was not eligible for graduation. Yet, as McKenzie noted: ‘… even though he was one year behind … his original classmates … Billy was still apparently one of the gang …’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn50",
      "id": "c1_fnr50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Further, addressing accounts that Billy Bishop did not return to RMC, McKenzie points to records that show that Billy reported back on ‘28 August 1914, as did all but one member of the new 1st Class’. Further, ‘[Billy] Bishop, now a senior, was appointed [by the college commandant] a lance-corporal; of his other classmates, three received no appointment at all. One week later … he was appointed to corporal … [Thus], despite his poor\n"), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("\nacademic showing, Bishop was given some rank. He was deemed worthy of trust. Nothing here suggests he was under a cloud …’ "), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn51",
      "id": "c1_fnr51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By that time, events in Europe since the assassination of Austro-Hungarian Archduke Franz Ferdinand and his wife Sophie in June 1914 had escalated to a state of war. The Triple Entente of Britain, France and Russia faced the Central Powers led by the German and Austro-Hungarian Empires.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As young men in all the belligerent nations flocked to recruiting stations, at the RMC fifteen of Billy’s classmates left the college on Wednesday, 16 September to accept special commissions in the British Army. Twelve days later, the RMC commandant, Colonel (later Brigadier-General) Lancelot R. Carleton, DSO"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn52",
      "id": "c1_fnr52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(", forwarded Billy’s application to join the war effort:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘I have the honour to request that Gentleman Cadet W.A. Bishop may have leave to withdraw from the college as he is applying for a commission in the 9th Mississauga Horse, at the request of the officer commanding that Corps, and has his father’s consent.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn53",
      "id": "c1_fnr53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On Wednesday, 30 September, Billy was recorded as being discharged from the RMC ‘at parents’ request’,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn54",
      "id": "c1_fnr54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" a term that McKenzie explains ‘seems to have been used in the [RMC] ledger for every departure from the college except for those resulting from graduation, academic failure, or expulsion … The timing of Bishop’s departure from RMC is therefore not at all suspicious. His low academic standing no doubt ensured he wasn’t [granted] one of the special commissions, but the departure of his friends may well have stirred him to act on his own.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn55",
      "id": "c1_fnr55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the beginning of World War I, ‘Canada was woefully short of officers’, Arthur Bishop wrote. He noted that his father’s ‘military training, albeit incomplete, and his ability to ride a horse, won him quick acceptance’ into a local military unit. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn56",
      "id": "c1_fnr56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" The same day he was discharged from the RMC, former Cadet No. 943 William Avery Bishop was commissioned as a lieutenant in the Mississauga Horse"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c1_fn57",
      "id": "c1_fnr57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(", a Toronto-based cavalry detachment of the 2nd Canadian Division.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He could not have imagined that this action would propel him to the British Empire’s highest honours and world fame.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04e79638","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_c1.vue
// module id = 75
// module chunks = 0